import { z } from 'zod';
export const documentSelectionConfirmationFilterValues = ['pending', 'confirmed', 'all'] as const;
export type DocumentSelectionConfirmationFilter = (typeof documentSelectionConfirmationFilterValues)[number];
export const DocumentSelectionSearchSchema = z.object({
  confirmationFilter: z.enum(documentSelectionConfirmationFilterValues).optional().default('all'),
  page: z.number().optional().default(1),
  pageSize: z.number().optional().default(100)
});
export type DocumentSelectionSearch = z.infer<typeof DocumentSelectionSearchSchema>;